import { createEvmAddressId, isHex, toLowerHex } from '@pkg/evm'
import { createSolanaAddressId } from '@pkg/solana'
import type { ParseToAccountIds } from '../../types'
import {
  isSupportChain,
  supportChainEvmChainIds,
  supportSolanaChainName,
} from '../constants'
import type { Deposit } from './schema'

export const parseDepositHistoriesToAccountIds: ParseToAccountIds<Deposit> = (
  data,
) => {
  const accountIdSet = new Set<string>()
  for (const item of data) {
    // support chain 以外はスキップ
    if (!isSupportChain(item.chain)) {
      continue
    }

    // evm だったら account id 作成して追加
    const chainId = supportChainEvmChainIds[item.chain]
    if (chainId !== undefined && isHex(item.address)) {
      accountIdSet.add(
        createEvmAddressId({ chainId, address: toLowerHex(item.address) }),
      )
    }
    // solana だったら account id 作成して追加
    else if (item.chain === supportSolanaChainName) {
      accountIdSet.add(createSolanaAddressId({ address: item.address }))
    }
  }
  return [...accountIdSet]
}
